import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProductListPage from '../pages/shop/ProductListPage';
import ProductDetailPage from '../pages/shop/ProductDetailPage';
import CartPage from '../pages/shop/CartPage';
import CheckoutPage from '../pages/shop/CheckoutPage';
import OrderConfirmationPage from '../pages/shop/OrderConfirmationPage';
import MyOrdersPage from '../pages/shop/MyOrdersPage';
import OrderDetailsPage from '../pages/shop/OrderDetailsPage';
import CustomerProfilePage from '../pages/shop/CustomerProfilePage';

const ShopRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Le préfixe /boutique est déjà géré par le parent */}
      <Route index element={<ProductListPage />} />
      <Route path="produit/:slug" element={<ProductDetailPage />} />
      <Route path="panier" element={<CartPage />} />
      <Route path="checkout" element={<CheckoutPage />} />
      <Route path="confirmation/:orderCode" element={<OrderConfirmationPage />} />
      <Route path="commandes" element={<MyOrdersPage />} />
      <Route path="commandes/:id" element={<OrderDetailsPage />} />
      <Route path="profil" element={<CustomerProfilePage />} />
      <Route path="*" element={<Navigate to="/boutique" replace />} />
    </Routes>
  );
};

export default ShopRoutes;
